namespace $.$$ {

	$mol_style_define( $shm_hitalama_map_page_arrow, {

		position: 'absolute',
		height: 0,
		pointerEvents: 'none',
		transformOrigin: '0 0',
		transition: 'none',
		overflow: 'visible',
		opacity: .72,

		Line: {
			position: 'absolute',
			left: 0,
			top: '-1px',
			width: '100%',
			height: '2px',
			transition: 'none',
			background: {
				color: $mol_theme.control,
			},
		},

		Head: {
			position: 'absolute',
			right: '-1px',
			top: '-5px',
			width: 0,
			height: 0,
			transition: 'none',
			borderTop: '5px solid transparent',
			borderBottom: '5px solid transparent',
			borderLeft: '8px solid var(--mol_theme_control)',
		},

		// '[shm_hitalama_map_page_arrow_kind]': {
		// 	code: {
		// 		Line: {
		// 			background: {
		// 				color: $mol_theme.current,
		// 			},
		// 		},
		// 		Head: {
		// 			borderLeft: '8px solid var(--mol_theme_current)',
		// 		},
		// 	},
		// 	table: {
		// 		Line: {
		// 			background: {
		// 				color: $mol_theme.focus,
		// 			},
		// 		},
		// 		Head: {
		// 			borderLeft: '8px solid var(--mol_theme_focus)',
		// 		},
		// 	},
		// 	value: {
		// 		Line: {
		// 			background: {
		// 				color: $mol_theme.shade,
		// 			},
		// 		},
		// 		Head: {
		// 			borderLeft: '8px solid var(--mol_theme_shade)',
		// 		},
		// 	},
		// },

	} )

}
